import { SDK } from '../index';
import {
    ProfileText,
    ProfileTextsQueryVariables,
    ResultSuccess,
} from '../generated/graphql';
import { FetchPolicy } from '@apollo/client/core/watchQueryOptions';

export const findManyProfileText = async (
    sdk: SDK,
    fetchPolicy: FetchPolicy = 'cache-first',
): Promise<Array<ProfileText> | ResultSuccess> => {
    const query = require('../graphql/queries/profileTexts.query.gql');
    return sdk.query<
        {
            findManyProfileText: Array<ProfileText>;
        },
        ProfileTextsQueryVariables
    >(
        {
            query: query,
            fetchPolicy,
        },
        'findManyProfileText',
    );
};
